import {Component, computed, inject, output, signal} from '@angular/core';
import {availableProductsStore} from "../../store/available-products.store";
import {groupBy} from "../../util/groupBy";
import {LamellaListingItem} from "../../types/lamella-listing-item.type";


@Component({
  selector: 'app-product-selector',
  imports: [],
  templateUrl: './product-selector.component.html',
  styleUrl: './product-selector.component.scss',
  styles: ' :host{ @apply bg-white; }'
})
export class ProductSelectorComponent {
  private availableProductStore = inject(availableProductsStore);
  private availableProducts = this.availableProductStore.availableLamellas;


  protected searchTerm = signal('');

  protected listedProducts = computed(() => {
    return this.searchTerm() === ''
      ? this.availableProducts()
      : this.availableProducts().filter((product) =>
            product.productName.toLowerCase().includes(this.searchTerm().toLowerCase())
            || product.productCode.toLowerCase().includes(this.searchTerm().toLowerCase())
        );
  });

  protected groupedProducts = computed(() => groupBy(this.listedProducts() , 'lamellaCategory') );
  protected productFamilies = computed(() => this.groupedProducts()
      .map((group) =>
          group.every((product) => product.productFamily === group[0].productFamily)
            ? group[0].productFamily
            : 'muut'
      ));

  protected recentProducts = computed( () =>
      this.availableProductStore.recentProducts().filter((product) =>
          product.productName.toLowerCase().includes(this.searchTerm().toLowerCase())
          || product.productCode.toLowerCase().includes(this.searchTerm().toLowerCase())));


  selectedProduct = output<LamellaListingItem>()

  closeModal = output()

  //input search
  onSearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchTerm.set(inputElement.value);
  }

  //product click
  onSelect(item: any) {
    this.availableProductStore.addRecentProduct(item);
    this.selectedProduct.emit(item);
    this.closeModal.emit();
  }

  // Overlay click - Outside of the modal
  onOverlayClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal.emit();
    }
  }


}
